export default {
    SET_PAYMENT_LOGS: (state, paymentLogs) => {
        state.paymentLogs = paymentLogs
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    RESET_PAYMENT_LOGS: (state) => {
        state.paymentLogs = []
    }
}
